import React from 'react'
import styled from 'styled-components'

import RedeemList from '../../components/RedeemList'

const Wrapper = styled.section`
  width: 100%;
  ${({ small }) => !small && `margin-top: -150px;`};
`

const Container = styled.div`
  margin: 0 auto;
  padding: 0 0 ${({ small }) => (small ? '0' : `80px`)} 90px;
  width: 100%;
`

const Redeem = ({ redeemList, small }) => {
  return (
    <Wrapper small={small}>
      <Container small={small}>
        <RedeemList redeemList={redeemList} small={small} />
      </Container>
    </Wrapper>
  )
}

export default Redeem
